import React from 'react'
import First from '../../components/section1'
import Second from '../../components/section2'
import Third from '../../components/section3'
import Forth from '../../components/section4'
import Fifth from '../../components/section5'
import Sixth from '../../components/section6'
import Seventh from '../../components/section7'
import Eight from '../../components/section8'
import Header from '../../components/header'
import Footer from '../../components/footer'





export default function Home() {
  return (
    <>
     <div className='webbgImage'>
    <Header/>
    <First/>
    <Second/>
    <Third/>
    <Forth/>
    <Fifth/>
    <Sixth/>
    <Seventh/>
    <Eight/>
    <Footer/>
    </div>
    </>
  )
}
